import {Injectable, signal, computed} from '@angular/core';
import {RestServiceAbstract} from '../../base/rest.service.abstract';
import {ResponseModel} from '../../base/response.model';
import {map, throwError} from 'rxjs';
import {catchError, takeUntil} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})

export class CommunicationRestService extends RestServiceAbstract {

  private unreadCount = signal<number>(0);
  hasNewMessages = computed(() => this.unreadCount() > 0);


  getConfigs(idf: string) {
    return this.get(`/${this.USERMANAGEMENT}/communication/config/${idf}`).pipe(map(data => {
      return new ResponseModel(data);
    }));
  }

  saveConfig(idf: any, data: Object) {
    return this.post(`/${this.USERMANAGEMENT}/communication/config/${idf}`, data).pipe(map(response => {
      return new ResponseModel(response);
    }));
  }

  disable(idf: string, type: string) {
    return this.put(`/${this.USERMANAGEMENT}/communication/config/disable/${idf}/${type}`, {}).pipe(map(response => {
      return new ResponseModel(response);
    }));
  }

  hasCustomerInformation(idf: string, configType?: string) {
    return this.get(`/${this.USERMANAGEMENT}/communication/messages/hasMessage/${idf}/TRACK_TRACE`).pipe(map(data => {
      return data;
    }));
  }

  getCustomerInformation(idf: string, configType?: string) {
    return this.get(`/${this.USERMANAGEMENT}/communication/messages/${idf}`).pipe(map(data => {
      return new ResponseModel(data);
    }));
  }

  getCustomerPopup(idf: string, configType?: string) {
    return this.get(`/${this.USERMANAGEMENT}/communication/messages/active/${idf}`).pipe(map(data => {
      return new ResponseModel(data);
    }));
  }

  setMessageStatus(id: number, idf: string, status: string) {
    return this.post(`/${this.USERMANAGEMENT}/communication/messages/readMessage`, {
      id: id,
      idf: idf,
      status: status
    }).pipe(map(response => {
      return new ResponseModel(response);
    }));
  }

  getMessagesChildren(id: number, idf: string) {
    return this.get(`/${this.USERMANAGEMENT}/communication/messages/${id}/children`, {
      params: {
        idf:
        idf
      }
    }).pipe(
      map(data => {
        return new ResponseModel(data);
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
